import {
  BriefcaseBusinessIcon,
  Building2Icon,
  ContactRoundIcon,
  FileTextIcon,
  LayersIcon,
  MagnetIcon,
  MailIcon,
  PhoneIcon,
  ReceiptTextIcon,
  SquareCheckIcon,
  UsersRoundIcon,
  type LucideIcon,
} from 'lucide-react';

import type { ActivityType, EntityType } from '../api';

export const ENTITY_ICONS: Record<EntityType, LucideIcon> = {
  lead: MagnetIcon,
  deal: BriefcaseBusinessIcon,
  contact: ContactRoundIcon,
  company: Building2Icon,
  quote: FileTextIcon,
  invoice: ReceiptTextIcon,
  item: LayersIcon,
};

export const ACTIVITY_ICONS: Record<ActivityType, LucideIcon> = {
  call: PhoneIcon,
  meeting: UsersRoundIcon,
  email: MailIcon,
  todo: SquareCheckIcon,
};
